import React from 'react';
import AtlasV2TrafficShareSplineChart from 'src/components/AtlasV2Components/AtlasV2graphs/AtlasV2TrafficShareSplineChart';

const AtlasV2OrganicTrafficShareChart = () => {
  return (
    <AtlasV2TrafficShareSplineChart fieldName="organicClicks" title="Share of Organic Traffic" trafficLabel="organic traffic" />
  );
};

export default AtlasV2OrganicTrafficShareChart;
